export default function LazyNode(value, next) {
	this.value = value;
	this.next = next;
}
